import { Select as AntdSelect } from "antd";
import React from "react";

import "./styles.css";

const { Option } = AntdSelect;

const Select = props => {
  const {
    defaultValue,
    arrayValue,
    optionsArray = [],
    placeholder = "",
    allowClear = true,
    mode = "multiple",
    maxTagCount = "responsive",
    width = "100%",
    valueKey = null,
    labelKey = null,
    showSearch = true,
    callback = () => {},
    onDeselect = () => {},
    onClear = () => {},
    className = "",
    ...restOfProps
  } = props;

  const optionsArr = [...(optionsArray || [])];

  const onChangeFn = data => {
    callback(data);
  };

  const onDeselectFn = data => {
    onDeselect(data);
  };

  const onClearData = (item, dat) => {
    onClear(item, dat);
  };

  return (
    <AntdSelect
      {...restOfProps}
      defaultValue={defaultValue}
      maxTagCount={maxTagCount}
      placeholder={placeholder}
      showSearch={showSearch}
      allowClear={allowClear}
      value={arrayValue}
      mode={mode}
      style={{ width }}
      onDeselect={onDeselectFn}
      onChange={onChangeFn}
      onClear={onClearData}
      optionFilterProp="children"
      filterSort={(optionA, optionB) =>
        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
      }
      className={`select-box ${className}`}
    >
      {optionsArr &&
        optionsArr?.map(data => {
          const value = valueKey ? data[valueKey] : data.ObjectId || data.Name;
          const label = labelKey ? data[labelKey] : data.Name;
          return (
            <Option
              value={value}
              key={value}
              className="ant-select-options"
              style={{ zIndex: 2000 }}
            >
              {label}
            </Option>
          );
        })}
    </AntdSelect>
  );
};

export default React.memo(Select);
